import { EndNode, Section } from '@/components/ArticleElement'
import { AppLayout } from '@/components/Layouts/AppLayout'
import { SocialMediaLinks } from '@/components/Navigation/Footer'
import { useLanguage } from '@/hooks/Contexts'
import { Fragment } from 'react'

const AboutUs = () => {
  const {
    about_us: { descr, head, titles, paragraphs },
  } = useLanguage()
  return (
    <Fragment>
      <AppLayout title='contact' />
      <div className='fluid-gray !bg-stone-50'>
        <div className='container-gray flex flex-col items-center md:flex-row md:items-start'>
          <img src='/assets/contact_us.png' alt='Contact' className='w-full max-w-[200px] md:max-w-[280px]' />
          <Section paragraphs={descr} extraCls='mt-4 md:mt-0 md:ml-4' paragraphCls='mt-2 first:mt-0 !text-base' />
        </div>
      </div>
      <div className='fluid-gray'>
        <div className='container-gray grid w-full grid-cols-1 text-center md:grid-cols-3'>
          <div className='col-span-full font-semibold'>{head}</div>
          {titles.map((title, i) => (
            <div key={i} className={`card-container col-span-1 mt-4 flex flex-col justify-between p-4${i === 0 ? '' : ' md:ml-4'}`}>
              <div className='font-medium'>{title}</div>
              {i > 0 ? (
                paragraphs[i - 1].map((paragraph, i) => (
                  <p key={`paragraph-${i}`} className='pt-2 text-sm'>
                    <EndNode content={paragraph} />
                  </p>
                ))
              ) : (
                <SocialMediaLinks className='justify-center' iconCls='text-cyan-v2 w-12 h-12 mt-2 ml-4 first:ml-0' />
              )}
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  )
}

export default AboutUs
